import React from "react";
import { useRef } from "react";
import { useSelector } from "react-redux";
// Utils
import { useState } from "react";
import { toast } from "react-toastify";
import SpinnerComp from "../util/SpinnerComp";
import { orikamiDomain } from "../../features/urlConst/domainUrl";
// import axios from 'axios'

const ConfigurationFileUpload = () => {
  //   redux
  const { user_info, token } = useSelector((state) => state.auth);

  // Upload State for Price
  const [uploadLoadingPrice, setUploadLoadingPrice] = useState(false);
  const [uploadProgressPrice, setUploadProgressPrice] = useState(0);

  // Upload State for Destination
  const [uploadLoadingDestination, setUploadLoadingDestination] =
    useState(false);
  const [uploadProgressDestination, setUploadProgressDestination] = useState(0);

  // Upload State for Holiday
  const [uploadLoadingHoliday, setUploadLoadingHoliday] = useState(false);
  const [uploadProgressHoliday, setUploadProgressHoliday] = useState(0);

  // Upload State for Destination
  const [uploadLoadingThickness, setUploadLoadingThickness] = useState(false);
  const [uploadProgressThickness, setUploadProgressThickness] = useState(0);

  // Upload State for Geo Json
  const [uploadLoadingGeoJson, setUploadLoadingGeoJson] = useState(false);
  const [uploadProgressGeoJson, setUploadProgressGeoJson] = useState(0);

  // Upload State for Geo Json
  const [uploadLoadingFileAny, setUploadLoadingFileAny] = useState(false);
  const [uploadProgressFileAny, setUploadProgressFileAny] = useState(0);

  // Upload to Websocket
  const uploadToWebSocket = (data, size, file_type) => {
    let fileSize = 0;
    const parseFile = (file, callback) => {
      fileSize = size;
      let chunkSize = 256 * 1024;
      let offset = 0;
      let block = null;

      let foo = (e) => {
        if (e.target.error === null) {
          offset += chunkSize;
          callback(e.target.result, offset, e.target.result.length);
        } else {
          console.log("Read error :" + e.target.error);
          return;
        }

        if (offset >= fileSize) {
          // console.log('Done reading file')
          callback("", offset, 0);
          return;
        }

        block(offset, chunkSize, file);
      };

      block = (_offset, length, _file) => {
        let r = new FileReader();
        let blob = _file.slice(offset, length + _offset);
        r.onload = foo;
        r.readAsText(blob);
      };
      block(offset, chunkSize, file);
    };

    // let sock = new WebSocket('wss://orikomi-quote-api.107.jp:9010')
    let sock = new WebSocket("wss://" + orikamiDomain + ":8089/");
    let beforePercentage = 0;
    sock.onmessage = (e) => {
      // console.log('onmessage')
      let data = JSON.parse(e.data);
      let process = parseInt(data.process, 10);
      // console.log(file_type + ' : ' + data.result)
      // console.log({ data, beforePercentage, process })
      if (beforePercentage < process) {
        if (file_type === "price/csv") {
          setUploadProgressPrice(process);
        }
        if (file_type === "destinations/csv") {
          setUploadProgressDestination(process);
        }
        if (file_type === "holidays/csv") {
          setUploadProgressHoliday(process);
        }
        if (file_type === "thickness_condition/csv") {
          setUploadProgressThickness(process);
        }
        if (file_type === "geojson") {
          setUploadProgressGeoJson(process);
        }
        if (file_type === "any") {
          setUploadProgressFileAny(process);
        }
      }
      if (
        // (data.result === 'process' && data.err !== '') ||
        // data.result === 'failure'
        // ||
        // data.err === ''
        data.result === "failure"
      ) {
        if (
          !uploadLoadingPrice &&
          !uploadLoadingDestination &&
          !uploadLoadingHoliday &&
          !uploadLoadingThickness &&
          !uploadLoadingGeoJson &&
          !uploadLoadingFileAny
        ) {
          sock.close();
        }
        if (file_type === "price/csv") {
          setUploadLoadingPrice(false);
          setUploadProgressPrice(0);
          toast.error("価格表アップロード " + data.err);
        }
        if (file_type === "destinations/csv") {
          setUploadLoadingDestination(false);
          setUploadProgressDestination(0);
          toast.error("仕向地リストアップロード " + data.err);
        }
        if (file_type === "holidays/csv") {
          setUploadLoadingHoliday(false);
          setUploadProgressHoliday(0);
          toast.error("休業日リストアップロード " + data.err);
        }
        if (file_type === "thickness_condition/csv") {
          setUploadLoadingThickness(false);
          setUploadProgressThickness(0);
          toast.error("厚さ条件アップロード " + data.err);
        }
        if (file_type === "geojson") {
          setUploadLoadingGeoJson(false);
          setUploadProgressGeoJson(0);
          toast.error("ジオJSONアップロード " + data.err);
        }
        if (file_type === "any") {
          setUploadLoadingFileAny(false);
          setUploadProgressFileAny(0);
          toast.error("任意のファイルアップロード " + data.err);
        }
      }
      if (data.result === "fin" || data.result === "success") {
        if (
          !uploadLoadingPrice &&
          !uploadLoadingDestination &&
          !uploadLoadingHoliday &&
          !uploadLoadingThickness &&
          !uploadLoadingGeoJson &&
          !uploadLoadingFileAny
        ) {
          sock.close();
          // console.log({ data, msg: 'close websocket' })|| data.result === 'success'cons
        }
        if (
          file_type === "price/csv" &&
          (data.result === "fin" || data.result === "success")
        ) {
          setUploadLoadingPrice(false);
          setUploadProgressPrice(0);
          toast.success("価格表ファイルが正常にアップロードされました");
        }
        if (
          file_type === "destinations/csv" &&
          (data.result === "fin" || data.result === "success")
        ) {
          setUploadLoadingDestination(false);
          setUploadProgressDestination(0);
          toast.success("仕向地ファイルのアップロードに成功しました");
        }
        if (
          file_type === "holidays/csv" &&
          (data.result === "fin" || data.result === "success")
        ) {
          setUploadLoadingHoliday(false);
          setUploadProgressHoliday(0);
          toast.success("定休日ファイルのアップロードに成功しました");
        }
        if (
          file_type === "thickness_condition/csv" &&
          (data.result === "fin" || data.result === "success")
        ) {
          setUploadLoadingThickness(false);
          setUploadProgressThickness(0);
          toast.success("厚さ条件ファイルのアップロードに成功しました");
        }
        if (
          file_type === "geojson" &&
          (data.result === "fin" || data.result === "success")
        ) {
          setUploadLoadingGeoJson(false);
          setUploadProgressGeoJson(0);
          toast.success("ジオJSONファイルのアップロードに成功しました");
        }
        if (
          file_type === "any" &&
          (data.result === "fin" || data.result === "success")
        ) {
          // console.log('any sukses')
          setUploadLoadingFileAny(false);
          setUploadProgressFileAny(0);
          toast.success("ファイルのアップロードに成功しました");
        }
      }
    };

    sock.onopen = () => {
      // console.log('onopen')
      let file = data;
      let senDataPre = {
        user_id: user_info.user_id,
        file_size: size,
        file_type: file_type,
        file_name: file.name,
        token: token,
      };
      // console.log(senDataPre)
      let sendJsonpre = JSON.stringify(senDataPre);
      sock.send(sendJsonpre);
      parseFile(file, function (result, offset, size) {
        sock.send(result);
      });
    };
  };

  //   Price Upload
  const hiddenPriceFileInput = useRef(null);
  const [filePrice, setFilePrice] = useState(null);
  const [filePriceError, setFilePriceError] = useState(null);
  const handleClickPrice = (event) => {
    hiddenPriceFileInput.current.click();
  };
  const handlePriceFileChange = (e) => {
    if (
      e.target.files[0].type === "text/csv" ||
      e.target.files[0].type === "application/vnd.ms-excel"
    ) {
      setFilePrice(e.target.files[0]);
      setFilePriceError("");
    } else {
      setFilePrice(null);
      setFilePriceError(
        "無効なファイルタイプです。csvファイルをアップロードしてください。"
      );
    }
  };
  const submitPriceUpload = (e) => {
    e.preventDefault();
    if (!uploadLoadingPrice) {
      if (filePrice === null) return toast.error("入力ファイル");
      setUploadLoadingPrice(true);

      const data = filePrice;
      const size = filePrice.size;
      const file_type = "price/csv";

      uploadToWebSocket(data, size, file_type);
      setUploadLoadingPrice(true);
      setFilePrice(null);
    }
  };

  //   Destination Upload
  const hiddenDestinationFileInput = useRef(null);
  const [fileDestination, setFileDestination] = useState(null);
  const [fileDestinationError, setFileDestinationError] = useState(null);
  const handleClickDestination = (event) => {
    hiddenDestinationFileInput.current.click();
  };
  const handleDestinationFileChange = (e) => {
    if (
      e.target.files[0].type === "text/csv" ||
      e.target.files[0].type === "application/vnd.ms-excel"
    ) {
      setFileDestination(e.target.files[0]);
      setFileDestinationError("");
    } else {
      setFileDestination(null);
      setFileDestinationError(
        "無効なファイルタイプです。csvファイルをアップロードしてください。"
      );
    }
  };
  const submitDestinationUpload = (e) => {
    e.preventDefault();
    if (!uploadLoadingDestination) {
      if (fileDestination === null) return toast.error("入力ファイル");

      const data = fileDestination;
      const size = fileDestination.size;
      const file_type = "destinations/csv";

      uploadToWebSocket(data, size, file_type);
      setUploadLoadingDestination(true);
      setFileDestination(null);
    }
  };

  //   Close Day Upload
  const hiddenCloseDayFileInput = useRef(null);
  const [fileClosedDay, setFileClosedDay] = useState(null);
  const [fileClosedDayError, setFileClosedDayError] = useState(null);
  const handleClickCloseDay = (event) => {
    hiddenCloseDayFileInput.current.click();
  };
  const handleCloseDayFileChange = (e) => {
    if (
      e.target.files[0].type === "text/csv" ||
      e.target.files[0].type === "application/vnd.ms-excel"
    ) {
      setFileClosedDay(e.target.files[0]);
      setFileClosedDayError("");
    } else {
      setFileClosedDay(null);
      setFileClosedDayError(
        "無効なファイルタイプです。csvファイルをアップロードしてください。"
      );
    }
  };
  const submitClosedDayUpload = (e) => {
    e.preventDefault();
    if (!uploadLoadingHoliday) {
      if (fileClosedDay === null) return toast.error("入力ファイル");

      const data = fileClosedDay;
      const size = fileClosedDay.size;
      const file_type = "holidays/csv";

      uploadToWebSocket(data, size, file_type);
      setUploadLoadingHoliday(true);
      setFileClosedDay(null);
    }
  };

  //   Thickness
  const hiddenThicknessFileInput = useRef(null);
  const [fileThickness, setFileThickness] = useState(null);
  const [fileThicknessError, setFileThicknessError] = useState(null);
  const handleClickThickness = (event) => {
    hiddenThicknessFileInput.current.click();
  };
  const handleThicknessFileChange = (e) => {
    if (
      e.target.files[0].type === "text/csv" ||
      e.target.files[0].type === "application/vnd.ms-excel"
    ) {
      setFileThickness(e.target.files[0]);
      setFileThicknessError("");
    } else {
      setFileClosedDay(null);
      setFileThicknessError(
        "無効なファイルタイプです。csvファイルをアップロードしてください。"
      );
    }
  };
  const submitThicknessUpload = (e) => {
    e.preventDefault();
    if (!uploadLoadingThickness) {
      if (fileThickness === null) return toast.error("入力ファイル");

      const data = fileThickness;
      const size = fileThickness.size;
      const file_type = "thickness_condition/csv";

      uploadToWebSocket(data, size, file_type);
      setUploadLoadingThickness(true);
      setFileThickness(null);
    }
  };

  //   Geo Json
  const hiddenGeoJsonFileInput = useRef(null);
  const [fileGeoJson, setFileGeoJson] = useState(null);
  const [fileGeoJsonError, setFileGeoJsonError] = useState(null);
  const handleClickGeoJson = (event) => {
    hiddenGeoJsonFileInput.current.click();
  };
  const handleGeoJsonFileChange = (e) => {
    setFileGeoJson(e.target.files[0]);
  };
  const submitGeoJsonUpload = (e) => {
    e.preventDefault();
    if (!uploadLoadingGeoJson) {
      if (fileGeoJson === null) return toast.error("入力ファイル");
      setUploadLoadingGeoJson(true);

      const data = fileGeoJson;
      const size = fileGeoJson.size;
      const file_type = "geojson";

      uploadToWebSocket(data, size, file_type);
      setFileGeoJson(null);
    }
  };

  //   File Any
  const hiddenFileAnyFileInput = useRef(null);
  const [fileAny, setFileAny] = useState(null);
  const handleClickFileAny = (event) => {
    hiddenFileAnyFileInput.current.click();
  };
  const handleFileAnyFileChange = (e) => {
    setFileAny(e.target.files[0]);
  };
  const submitFileAnyUpload = (e) => {
    e.preventDefault();
    if (!uploadLoadingFileAny) {
      if (fileAny === null) return toast.error("入力ファイル");
      setUploadLoadingFileAny(true);

      const data = fileAny;
      const size = fileAny.size;
      const file_type = "any";
      // console.log({
      //   data,
      //   size,
      //   file_type,
      //   token,
      // })
      uploadToWebSocket(data, size, file_type);
      setFileAny(null);
    }
  };

  return (
    <div className="w-full flex justify-between px-2 items-end mt-12">
      <div className="w-full flex flex-col">
        <h1 className="font-semibold text-xl py-2 text-center">
          設定ファイルアップロード :
        </h1>

        <div className="w-full w-12/12 flex flex-col justify-center gap-4 mt-6">
          {/* Price Uplaod */}
          <div className="w-full w-12/12">
            <p className="w-full h-[1px] bg-gray-500"></p>
            <h1 className="mt-[2px] mb-4">
              全国新聞販売店部数単価リスト (csv) :
            </h1>
            <div className="flex justify-around items-center">
              <form
                className="w-8/12 flex gap-2 text-white font-semibold"
                encType="multipart/form-data"
                method="POST"
                onSubmit={submitPriceUpload}
              >
                <button
                  type="button"
                  onClick={handleClickPrice}
                  className="w-6/12 bg-gray-300 text-black py-2 text-xs md:text-base"
                >
                  ファイルを選択
                </button>
                <input
                  ref={hiddenPriceFileInput}
                  onChange={handlePriceFileChange}
                  id="csvInput"
                  name="file"
                  type="File"
                  style={{ display: "none" }}
                />
                <button
                  type="submit"
                  className={
                    `w-6/12 bg-blue-700 py-2 text-xs md:text-base ` +
                    `${uploadLoadingPrice && "cursor-not-allowed"}`
                  }
                >
                  価格リスト
                </button>
              </form>
              <div className="w-4/12 flex flex-col items-center justify-center">
                {uploadLoadingPrice && (
                  <>
                    <SpinnerComp />
                    <p>{uploadProgressPrice} %</p>
                  </>
                )}
              </div>
            </div>
            {filePriceError && (
              <p className="text-red-600">
                <span
                  onClick={() => setFilePriceError(null)}
                  className="text-white text-xs cursor-pointer bg-black px-[4px] rounded-full"
                >
                  X
                </span>{" "}
                {filePriceError}
              </p>
            )}
            {filePrice && (
              <>
                <p
                  onClick={() => setFilePrice(null)}
                  className="text-red-600 cursor-pointer"
                >
                  delete
                </p>

                <p className="font-bold py-[2px]">
                  File Choosen :{" "}
                  <span className="text-black font-normal ml-4">
                    {filePrice.name}
                  </span>
                </p>
              </>
            )}
          </div>
          {/* End Price Uplaod */}

          {/* Destinatoin Uplaod */}
          <div className="w-full w-12/12">
            <p className="w-full h-[1px] bg-gray-500"></p>
            <h1 className="mt-[2px] mb-4">納品先リスト (csv) :</h1>
            <div className="flex justify-center items-center">
              <form
                className="w-8/12 flex gap-2 text-white font-semibold"
                encType="multipart/form-data"
                method="POST"
                onSubmit={submitDestinationUpload}
              >
                <button
                  type="button"
                  onClick={handleClickDestination}
                  className="w-6/12 bg-gray-300 text-black py-2 text-xs md:text-base"
                >
                  ファイルを選択
                </button>
                <input
                  ref={hiddenDestinationFileInput}
                  onChange={handleDestinationFileChange}
                  id="csvInput"
                  name="file"
                  type="File"
                  style={{ display: "none" }}
                />
                <button
                  type="submit"
                  className={
                    `w-6/12 bg-blue-700 py-2 text-xs md:text-base ` +
                    `${uploadLoadingDestination && "cursor-not-allowed"}`
                  }
                >
                  納品先リスト
                </button>
              </form>
              <div className="w-4/12 flex flex-col items-center justify-center">
                {uploadLoadingDestination && (
                  <>
                    <SpinnerComp />
                    <p>{uploadProgressDestination} %</p>
                  </>
                )}
              </div>
            </div>
            {fileDestinationError && (
              <p className="text-red-600">
                <span
                  onClick={() => setFileDestinationError(null)}
                  className="text-white text-xs cursor-pointer bg-black px-[4px] rounded-full"
                >
                  X
                </span>{" "}
                {fileDestinationError}
              </p>
            )}
            {fileDestination && (
              <>
                <p
                  onClick={() => setFileDestination(null)}
                  className="text-red-600 cursor-pointer"
                >
                  delete
                </p>
                <p className="font-bold py-[2px]">
                  File Choosen :{" "}
                  <span className="text-black font-normal ml-4">
                    {fileDestination.name}
                  </span>
                </p>
              </>
            )}
          </div>
          {/* End Destinatoin Uplaod */}

          {/* Closed day Uplaod */}
          <div className="w-full w-12/12">
            <p className="w-full h-[1px] bg-gray-500"></p>
            <h1 className="mt-[2px] mb-4">休刊日リスト (csv) :</h1>
            <div className="flex justify-center items-center">
              <form
                className="w-8/12 flex gap-2 text-white font-semibold"
                encType="multipart/form-data"
                method="POST"
                onSubmit={submitClosedDayUpload}
              >
                <button
                  type="button"
                  onClick={handleClickCloseDay}
                  className="w-6/12 bg-gray-300 text-black py-2 text-xs md:text-base"
                >
                  ファイルを選択
                </button>
                <input
                  ref={hiddenCloseDayFileInput}
                  onChange={handleCloseDayFileChange}
                  id="csvInput"
                  name="file"
                  type="File"
                  style={{ display: "none" }}
                />
                <button
                  type="submit"
                  className={
                    `w-6/12 bg-blue-700 py-2 text-xs md:text-base ` +
                    `${uploadLoadingHoliday && "cursor-not-allowed"}`
                  }
                >
                  例外休刊日リスト
                </button>
              </form>
              <div className="w-4/12 flex flex-col items-center justify-center">
                {uploadLoadingHoliday && (
                  <>
                    <SpinnerComp />
                    <p>{uploadProgressHoliday} %</p>
                  </>
                )}
              </div>
            </div>
            {fileClosedDayError && (
              <p className="text-red-600">
                <span
                  onClick={() => setFileClosedDayError(null)}
                  className="text-white text-xs cursor-pointer bg-black px-[4px] rounded-full"
                >
                  X
                </span>{" "}
                {fileClosedDayError}
              </p>
            )}
            {fileClosedDay && (
              <>
                <p
                  onClick={() => setFileClosedDay(null)}
                  className="text-red-600 cursor-pointer"
                >
                  delete
                </p>
                <p className="font-bold py-[2px]">
                  File Choosen :{" "}
                  <span className="text-black font-normal ml-4">
                    {fileClosedDay.name}
                  </span>
                </p>
              </>
            )}
          </div>
          {/* End Closed day Uplaod */}

          {/* Thickness / Cardborard condition Uplaod */}
          <div className="w-full w-12/12">
            <p className="w-full h-[1px] bg-gray-500"></p>
            <h1 className="mt-[2px] mb-4">厚紙リスト (csv) :</h1>
            <div className="flex justify-center items-center">
              <form
                className="w-8/12 flex gap-2 text-white font-semibold"
                encType="multipart/form-data"
                method="POST"
                onSubmit={submitThicknessUpload}
              >
                <button
                  type="button"
                  onClick={handleClickThickness}
                  className="w-6/12 bg-gray-300 text-black py-2 text-xs md:text-base"
                >
                  ファイルを選択
                </button>
                <input
                  ref={hiddenThicknessFileInput}
                  onChange={handleThicknessFileChange}
                  id="csvInput"
                  name="file"
                  type="File"
                  style={{ display: "none" }}
                />
                <button
                  type="submit"
                  className={
                    `w-6/12 bg-blue-700 py-2 text-xs md:text-base ` +
                    `${uploadLoadingThickness && "cursor-not-allowed"}`
                  }
                >
                  厚紙条件リスト
                </button>
              </form>
              <div className="w-4/12 flex flex-col items-center justify-center">
                {uploadLoadingThickness && (
                  <>
                    <SpinnerComp />
                    <p>{uploadProgressThickness} %</p>
                  </>
                )}
              </div>
            </div>
            {fileThicknessError && (
              <p className="text-red-600">
                <span
                  onClick={() => setFileThicknessError(null)}
                  className="text-white text-xs cursor-pointer bg-black px-[4px] rounded-full"
                >
                  X
                </span>{" "}
                {fileThicknessError}
              </p>
            )}
            {fileThickness && (
              <>
                <p
                  onClick={() => setFileThickness(null)}
                  className="text-red-600 cursor-pointer"
                >
                  delete
                </p>
                <p className="font-bold py-[2px]">
                  File Choosen :{" "}
                  <span className="text-black font-normal ml-4">
                    {fileThickness.name}
                  </span>
                </p>
              </>
            )}
          </div>
          {/* End Thickness / Cardborard condition Uplaod */}

          {/* GEO Json Uplaod */}
          <div className="w-full w-12/12">
            <p className="w-full h-[1px] bg-gray-500"></p>
            <h1 className="mt-[2px] mb-4">シェイプファイル (geojson) :</h1>
            <div className="flex justify-center items-center">
              <form
                className="w-8/12 flex gap-2 text-white font-semibold"
                encType="multipart/form-data"
                method="POST"
                onSubmit={submitGeoJsonUpload}
              >
                <button
                  type="button"
                  onClick={handleClickGeoJson}
                  className="w-6/12 bg-gray-300 text-black py-2 text-xs md:text-base"
                >
                  ファイルを選択
                </button>
                <input
                  ref={hiddenGeoJsonFileInput}
                  onChange={handleGeoJsonFileChange}
                  id="csvInput"
                  name="file"
                  type="File"
                  style={{ display: "none" }}
                />
                <button
                  type="submit"
                  className={
                    `w-6/12 bg-blue-700 py-2 text-xs md:text-base ` +
                    `${uploadLoadingGeoJson && "cursor-not-allowed"}`
                  }
                >
                  GEOJSONファイル
                </button>
              </form>
              <div className="w-4/12 flex flex-col items-center justify-center">
                {uploadLoadingGeoJson && (
                  <>
                    <SpinnerComp />
                    <p>{uploadProgressGeoJson}</p>
                  </>
                )}
              </div>
            </div>
            {fileGeoJsonError && (
              <p className="text-red-600">
                <span
                  onClick={() => setFileGeoJsonError(null)}
                  className="text-white text-xs cursor-pointer bg-black px-[4px] rounded-full"
                >
                  X
                </span>{" "}
                {fileGeoJsonError}
              </p>
            )}
            {fileGeoJson && (
              <>
                <p
                  onClick={() => setFileGeoJson(null)}
                  className="text-red-600 cursor-pointer"
                >
                  delete
                </p>
                <p className="font-bold py-[2px]">
                  File Choosen :{" "}
                  <span className="text-black font-normal ml-4">
                    {fileGeoJson.name}
                  </span>
                </p>
              </>
            )}
          </div>
          {/* End GEO Json Uplaod */}

          {/* File Any Uplaod */}
          <div className="w-full w-12/12">
            <p className="w-full h-[1px] bg-gray-500"></p>
            <h1 className="mt-[2px] mb-4">ファイルテスト :</h1>
            <div className="flex justify-center items-center">
              <form
                className="w-8/12 flex gap-2 text-white font-semibold"
                encType="multipart/form-data"
                method="POST"
                onSubmit={submitFileAnyUpload}
              >
                <button
                  type="button"
                  onClick={handleClickFileAny}
                  className="w-6/12 bg-gray-300 text-black py-2 text-xs md:text-base"
                >
                  ファイルを選択
                </button>
                <input
                  ref={hiddenFileAnyFileInput}
                  onChange={handleFileAnyFileChange}
                  id="csvInput"
                  name="file"
                  type="File"
                  style={{ display: "none" }}
                />
                <button
                  type="submit"
                  className={
                    `w-6/12 bg-blue-700 py-2 text-xs md:text-base ` +
                    `${uploadLoadingFileAny && "cursor-not-allowed"}`
                  }
                >
                  ファイルテスト
                </button>
              </form>
              <div className="w-4/12 flex flex-col items-center justify-center">
                {uploadLoadingFileAny && (
                  <>
                    <SpinnerComp />
                    <p>{uploadProgressFileAny}</p>
                  </>
                )}
              </div>
            </div>
            {fileAny && (
              <>
                <p
                  onClick={() => setFileAny(null)}
                  className="text-red-600 cursor-pointer"
                >
                  delete
                </p>
                <p className="font-bold py-[2px]">
                  File Choosen :{" "}
                  <span className="text-black font-normal ml-4">
                    {fileAny.name}
                  </span>
                </p>
              </>
            )}
          </div>
          {/* End File Any Uplaod */}
        </div>
      </div>
    </div>
  );
};

export default ConfigurationFileUpload;
